import React from 'react';
import classes from './TimePeriodSelector.module.scss';

import DatePicker from 'react-date-picker';
import moment from 'moment';
import { FaCalendarAlt } from 'react-icons/fa';
import { $t, $getLanguage } from '../../../helpers/translator';
import _ from "lodash";


class TimePeriodSelector extends React.Component {
    constructor(props) {
        super(props);
        this.startDateRef = React.createRef();
        this.endDateRef = React.createRef();

        this.state = {
            lang: $getLanguage(),
            startDate: this.props.startDate ? this.props.startDate : moment().subtract(1, 'months'),
            endDate: this.props.endDate ? this.props.endDate : moment(),

            periodError: '',
            timePeriods: null,

            restrictions: {
                maxDate: this.props.maxDate ? this.props.maxDate : null,
                minDate: this.props.minDate ? this.props.minDate : null,
                length: this.props.length ? this.props.length : null,       //allowed length of period [days]
            }
        };
    }

    componentDidMount() {
        // console.log('tp-cls',classes)
        let userTimezone = null;

        let startOfYear = moment('01-01-' + moment().format('YYYY'), 'MM-DD-YYYY');

        let timePeriods = {
            q1: {
                name: $t('global.dateTime.Q') + '1',
                startDate: moment(startOfYear),
                endDate: moment(startOfYear).add(3, 'M').subtract(1, 'd'),
                selectable: true,
                selected: false
            },
            q2: {
                name: $t('global.dateTime.Q') + '2',
                startDate: moment(startOfYear).add(3, 'M'),
                endDate: moment(startOfYear).add(6, 'M').subtract(1, 'd'),
                selectable: moment(moment(startOfYear).add(3, 'M')).isBefore(moment()),
                selected: false
            },
            q3: {
                name: $t('global.dateTime.Q') + '3',
                startDate: moment(startOfYear).add(6, 'M'),
                endDate: moment(startOfYear).add(9, 'M').subtract(1, 'd'),
                selectable: moment(moment(startOfYear).add(6, 'M')).isBefore(moment()),
                selected: false
            },
            q4: {
                name: $t('global.dateTime.Q') + '4',
                startDate: moment(startOfYear).add(9, 'M'),
                endDate: moment(startOfYear).add(12, 'M').subtract(1, 'd'),
                selectable: moment(moment(startOfYear).add(9, 'M')).isBefore(moment()),
                selected: false
            },
            year: {
                name: moment().format('YYYY'),
                startDate: moment(startOfYear),
                endDate: moment().endOf('year'),
                selectable: true,
                selected: false
            }
        };

        this.setState({ timePeriods: timePeriods }, () => {
            // console.log('timetime', this.state)
        });
    }

    setStartDate(date) {
        this.setState({ startDate: moment(date) });
        this.validatePeriod();
    }

    setEndDate(date) {
        this.setState({ endDate: moment(date) });
        this.validatePeriod();
    }

    selectTimePeriodOption(period) {
        if (!this.state.timePeriods[period].selectable) {
            return;
        }

        let newState = {
            startDate: this.state.timePeriods[period].startDate,
            endDate: this.state.timePeriods[period].endDate,
        };

        this.setState({
            startDate: newState.startDate,
            endDate: newState.endDate
        }, () => {
            this.validatePeriod();
        });
    }


    validatePeriod() {
        this.setState({ periodError: '' }, () => {

            if (this.state.restrictions.length && this.state.endDate.diff(this.state.startDate, 'days') > this.state.restrictions.length) {
                this.setState({ periodError: $t('validation.dateTime.maxDays') + ': ' +this.state.restrictions.length });
            }
            else if (!(this.state.endDate).isSameOrAfter(this.state.startDate, 'day')) {
                this.setState({ periodError: $t('validation.dateTime.periodNegative') });
            }
            else {
                this.emitUpdatedDates();

                //setting selected status for periods:
                let timePeriods = { ...this.state.timePeriods };
                _.forEach(timePeriods, (v, k) => {
                    v.selected = moment(v.startDate).isSame(this.state.startDate, 'day') && moment(v.endDate).isSame(this.state.endDate, 'day');
                });

                this.setState({ timePeriods: timePeriods });
            }
        });
    }

    emitUpdatedDates = () => {
        this.props.onDatesChange({
            startDate: this.state.startDate,
            endDate: this.state.endDate
        });
    };

    clickOnElement(ref) {
        this[ref].current.openCalendar();
    }

    render() {
        return (
            <div className={classes['container']}>

                <div className={classes['row-1'] + ' ' + classes['dates-container'] + ' ' + (this.state.periodError ? classes['error-border'] + ' ' : '')}
                     style={(this.props.styles ? this.props.styles : null)}>
                    <div className={classes['date-container']}>
                        <DatePicker
                            clearIcon={null}
                            className={classes['calendar-added-cls']}
                            value={this.state.startDate.toDate()}
                            locale={this.state.lang}

                            ref={this.startDateRef}
                            onChange={(date) => this.setStartDate(date)}
                        />

                        <DatePicker
                            clearIcon={null}
                            className={classes['calendar-added-cls']}
                            value={this.state.endDate.toDate()}
                            locale={this.state.lang}

                            // maxDate={this.state.restrictions.maxDate ? this.state.restrictions.maxDate : null}
                            ref={this.endDateRef}
                            onChange={(date) => this.setEndDate(date)}
                        />

                        <div onClick={() => this.clickOnElement('startDateRef')} style={{ cursor: 'pointer' }}>
                            {this.state.startDate.lang(this.state.lang).format('ll')}
                        </div>
                    </div>

                    <div>-</div>

                    <div className={classes['date-container']}>
                        <div onClick={() => this.clickOnElement('endDateRef')} style={{ cursor: 'pointer' }}>
                            {this.state.endDate.lang(this.state.lang).format('ll')}
                        </div>
                    </div>

                    <div className={classes['icon-container']}>
                        <FaCalendarAlt style={{ color: '#CCCCCC' }}/>
                    </div>
                </div>

                {this.state.periodError ?
                    <div className={classes['row-2']}>
                        <div className={classes['error']}>
                            {this.state.periodError}
                        </div>
                    </div>
                    :
                    null
                }

                {!this.props.hideQuarters ?
                    <div className={classes['row-3']}>
                        {this.state.timePeriods &&
                        <div className={classes['q-container']}>
                            {Object.keys(this.state.timePeriods).map((v, k) =>
                                <div key={k}
                                     onClick={() => this.selectTimePeriodOption(v)}
                                     className={(this.state.timePeriods[v].selectable ? ` ${classes['tp-selectable']} ` : ` ${classes['tp']} `) +
                                     (this.state.timePeriods[v].selected ? ` ${classes['tp-selectable']} ` : '')}
                                >{this.state.timePeriods[v].name}</div>
                            )}
                        </div>
                        }
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

export default TimePeriodSelector;
